__turbopack_context__.v({
  "legacyContent": "DialogCompat-module__UaYt9W__legacyContent",
});
